import { Plugin } from './plugin';
import { LoggerService } from 'rainbow-web-sdk/services/core/logger.service';
import { FileStorageService } from '../services/files/fileStorage.service';
import { FileServerService } from '../services/files/fileServer.service';
import { FileDocumentServiceRB } from '../services/fileDocument/fileDocument.service';

export class FileDocumentPlugin extends Plugin {
    public static initialize(): void {
        Plugin.initialize();

        if (!window.rainbow.plugins[FileDocumentPlugin.name]) {
            const logger = LoggerService.getInstance();
            logger.info("[DocumentsPlugin] initialized");
            window.rainbow.plugins[FileDocumentPlugin.name] = new FileDocumentPlugin();
            FileStorageService.getInstance();
            FileServerService.getInstance();
            FileDocumentServiceRB.getInstance();
        }
    }

    private constructor() {
        super();
    }
}
